import { API_URL_BASE, htmlElem, contentElem } from '../utils/globals';
import { setAjaxLoading, setAjaxComplete } from '../utils/ajaxLoaders';
import { removeChildNodes } from '../utils/removeChildNodes';
import { resetEmptyBlogItems } from '../utils/resetEmptyBlogItems';
import { resetNavigation } from './navigation';
import { indexPage } from '../utils/indexPage';
import { updatePushState } from '../utils/updatePushState';
import { removeFadeIn, addFadeIn } from '../utils/utils';
import { modal } from './modal';

const fetchPage = () => {
    const links = document.querySelectorAll('.nav__item');

    [...links].forEach(item => {
        item.addEventListener('click', (event) => {
            event.preventDefault();
            const slug = item.getAttribute('href').split('/')[1];
            removeFadeIn();
            
            fetch(`${API_URL_BASE}/pages?slug=${slug}`)
                .then((response) => response.json())
                .then((data) => {
                    setAjaxLoading(htmlElem);
                    removeChildNodes(contentElem);
                    const template = `<section>${data[0].content.rendered}</section>`;
                    contentElem.insertAdjacentHTML('beforeend', template);
                    updatePushState(slug);
                    indexPage();
                })
                .catch(err => console.log(err))
                .finally(() => {
                    resetEmptyBlogItems();
                    setAjaxComplete(htmlElem);
                    resetNavigation();
                    addFadeIn();
                    modal();
                });
        })
    })
}

export {
    fetchPage
}